import moment  from 'moment'

const state = {
    feriadosList: [],
    referenceYear: null,
    updateFeriado: null    
}
const getters = {
  senhaMask: () => (senha) =>  {
    let masked = (senha!=null && senha.length>0)? senha.replace(/([\w@.])/g, "*").split('') : [];
    return masked.join('');
  }
}
const mutations = {
    updateFeriadosList(state, data) {
        state.feriadosList = data
        state.referenceYear=null
    }
}
const actions = {
  formatDate ({state},date) {
    if (!date) return null
    if(state && date) {
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    }
  },
  parseDate ({state}, date) {
    if (!date) return null
    if(state && date) {
    const [day, month, year] = date.split('/')
    return `${year}-${month}-${day}`
    }
  },
  parsePrice ({state}, value) {
    if (!state || !value) return null
      value = (value.indexOf('.')>-1)? value.replaceAll(".", "") : value
      value = (value.indexOf(',')>-1)? value.replaceAll(",", ".") : value
      return parseFloat(value)
  },
  async getFeriados({ state }, opts){
      let geco = opts.grupoEconomico? opts.grupoEconomico : this.state.permissions.grupoEconomico
      let obj = {
          url: '/api/proxy/postdata', 
          query: [{ 
              Modulo: "Portal",
              Acao: "getferiados",
              Payload: {
                  grupo_economico: geco,
                  prestador_id: opts.prestador_id,
                  dt_inicio: opts.dt_inicio,
                  dt_fim: opts.dt_fim
              }
          }]
      }
      state.referenceYear = opts.referenceYear
      await this.dispatch("request/doRequest", obj).then(response => {
          state.feriadosList = response.dados
      });
  },
  async addFeriado({ state }, opts){
      let year = opts.yearSelect
      let obj = {
          url: '/api/proxy/postdata', 
          query: [{ 
              Modulo: "Portal",
              Acao: opts.acao,
              Payload: opts.payload
          }]
    }
    await this.dispatch("request/doRequest", obj)
        state.updateFeriado = year
  },
  async deleteFeriado({ state }, opts){
    let geco = opts.grupoEconomico? opts.grupoEconomico : this.state.permissions.grupoEconomico
    let obj = {
        url: '/api/proxy/postdata', 
        query: [{ 
            Modulo: "Portal",
            Acao: "deleteferiado",
            Payload: {
                grupo_economico: geco,
                id: opts.id
            }
        }]
    }
    await this.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.commit("hideLoader");
          return;
        }
        let paramModal = {
          type: "success",
          title: "Sucesso!",
          message: response.mensagem,
          callback: () => {
            state.updateFeriado = opts.year
          },
          btConfirm: { name: "Ok", show: true },
          btCancel: { name: 'Cancelar', show: false }
        }
        this.commit("confirmMessage/showConfirmMessage", paramModal);
      })
  },
  async getTipoGuias({ commit }, opts){
      let geco = opts.grupoEconomico? opts.grupoEconomico : this.state.permissions.grupoEconomico
      let obj = {
        query: [
          {
            Modulo: "Portal",
            Acao: "gettipoguias",
            Payload: { grupo_economico: geco, modulo_guia: opts.modulo_guia},
            noLoader: true
          },
        ],
      }
      let tipoGuiasList = await this.dispatch("request/doRequest", obj).then((response) => {
          if (!response || response.isAxiosError || response.error) {
              commit("hideLoader", null, {root: true})
              return []
          }
          let guiasList = response.dados;
          guiasList.unshift({id: null, descricao: "Selecione"})
        return guiasList
      })
      return tipoGuiasList
    },
    getCookie({state},cname) {
      var name = cname + "=";
      if(state){
          var decodedCookie = decodeURIComponent(document.cookie);
          var ca = decodedCookie.split(';')
          for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
              c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
            }
          }
          return null;
      }
    },
    setCookie({state},opts) {
      if(state){
          let [cname, cvalue, exdays] = opts
          var d = new Date();
          d.setTime(d.getTime() + (exdays*24*60*60*1000));
          var expires = "expires="+ d.toUTCString();
          document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      }
    },
    calculaDataInicio(dataI, dataF, periodo){
      let date = moment(dataF).add((periodo*-1), 'day').format('YYYY-MM-DD')
      return (!!dataI && Date.parse(dataI) < Date.parse(date))?  date : null
    },
    calculaDataFim(dataI, dataF, periodo){
      let date = moment(dataI).add(periodo, 'day').format('YYYY-MM-DD')
      return (!!dataF && Date.parse(dataF) > Date.parse(date))?  date : null
    }
} 
export default {
    namespaced: true,
    root: true,
    actions,
    mutations,
    state,
    getters
};